
import React from 'react';
import { Check } from 'lucide-react';

const ResellerPlanBenefits: React.FC = () => {
  const benefits = [
    "300 accounts signup capability",
    "Each account will have referral users as per the plan",
    "A Combined Total of 2,000,000 users can be added in the 300 accounts as per the plan",
    "You can point your domain name to an instance",
    "You get dedicated support and a priority ticket system",
    "You get a website front-end sales template that can be published on WordPress or any HTML-based site",
    "You will get a complete pre-made banner set to promote your services in any media",
    "You have complete integration that is allowed as per the plan",
    "You can offer a 7-day free trial. The billing will take place automatically at the end of the 7-day trial",
    "We process all the payments for customer plans they sign up for under a Referral Platform name",
    "Pricing is set at the minimum required selling price; you cannot sell for less, but you can sell for more",
    "The revenue share is based on volume, which will be outlined in the welcome email",
    "There is an annual minimum sales requirement of any 20 plans signed up; otherwise, a yearly maintenance fee of $299.00 will be charged to the reseller. We are looking for only a serious seller who can perform"
  ];

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 flex-grow">
      <h2 className="text-2xl font-bold mb-6 text-primary-blue">
        What Do You Get?
      </h2>
      <ul className="space-y-4">
        {benefits.map((benefit, index) => (
          <li key={index} className="flex items-start gap-3 group">
            <div className="mt-1 bg-blue-50 rounded-full p-1 group-hover:bg-blue-100 transition-colors flex-shrink-0">
              <Check className="h-4 w-4 text-primary-blue" />
            </div>
            <span className="text-gray-700">
              {benefit}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ResellerPlanBenefits;
